import { render, staticRenderFns } from "./generalAccountingStatement.vue?vue&type=template&id=56def624&"
import script from "./generalAccountingStatement.vue?vue&type=script&lang=js&"
export * from "./generalAccountingStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports